import { Component, AfterContentInit, ElementRef, OnInit, OnDestroy, Optional } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { ResultTypeDTO } from '../../api/plyca-dtos-v2';
import { BaseFormComponent, BaseFormHeaderInfo } from '../../tasks/baseFormComponent/baseForm.component';
import { AppConfiguration } from '../../conf/app.configuration';
import { Configuration } from '../../conf/app.constants';

import { HelpService } from '../../components/common/help/help.service';
import { of, Observable } from 'rxjs';
import { FormConfig } from '../../components/forms/form.objects';
import { tap, catchError, finalize, map } from 'rxjs/operators';
import * as lodash from 'lodash';

import { InterfaceSettings } from '../../api/contract-notice-dto';
import { forkJoin, ObservableInput } from 'rxjs';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { PersonDTO } from '../../api/plyca-dtos';
import { OrderProjectDTO, Coordination2DTO, AnnuityAmountDTO, BugdetaryBreakdownDTO, BudgetaryProjectDTO, OrderPlannedPeriodDTO } from '../../api/sarga-dtos';
import { formElementComponent } from '../../components/forms/formElement.component';
import { SearchSettingDTOModal, searchGenericComponent } from '../../components/search/searchGeneric.component';


export class OrderProjectModel {

  dto: OrderProjectDTO;
  ui: {
    isContextWork?: boolean,
    isPreviusPhase?: boolean,
    annuitiesList?: any[],
    incomeConcepts?: any[],
    costConcepts?: any[],
    costBreakdownList?: any[],
    incomeBreakdownList?: any[],
    totalBreakdownList?: any[],
    includeInternalCode?: boolean,
    includeCoordinationData?: boolean,
    includeIncidence?: boolean,
    planningBudgetData?: boolean,
    personaDataRequired?: boolean,
  }
}

@Component({
  selector: 'orderproject-form',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html'
})
export class OrderProjectsComponent
  extends BaseFormComponent<OrderProjectDTO, OrderProjectModel>
  implements OnInit, OnDestroy, AfterContentInit {
  headerService: any;
  private identifier: string;



  constructor(
    elem: ElementRef,
    @Optional() protected activatedRoute: ActivatedRoute,
    private router: Router,
    protected appConfig: AppConfiguration,
    public configuration: Configuration,
    private plycaErrorHandler: PlycaErrorHandler,
    public helpService: HelpService
  ) {
    super(elem);
    this.waitService.startWaiting();
    this.subscribe(this.activatedRoute.params
      .pipe(tap(params => (this.identifier = params['id'])))
    );
    this.waitService.cancelWaiting();

  }

  ngAfterContentInit(): void {

  }

  getFormSettingURL(): string {
    return 'orderprojects/orderProjectInterfaceSettings.json';
  }

  createFormConfig(): Observable<FormConfig> {

    let baseFormURL = this.getFormSettingURL();
    let orderProjectForm: Observable<InterfaceSettings>;
    let orderProjectFormURL = 'orderprojects/orderProjectInterfaceSettings.json';
    orderProjectForm = this.plycaService.getInterfaceSettings(orderProjectFormURL, true).pipe(
      catchError((e: any) => this.ignoreError(e, orderProjectFormURL))
    );

    // Desglose Presupuesatario
    let orderBreakdownFormURL = 'commonProjects/budgetaryBreakdownInterfaceSettings.json';
    let orderBreakdownForm: Observable<InterfaceSettings>;

    orderBreakdownForm = this.plycaService.getInterfaceSettings(orderBreakdownFormURL).pipe(
      catchError((e: any) => this.ignoreError(e, orderBreakdownFormURL))
    );

    // Desglose Presupuesatario
    let orderProjectFormURL2 = 'orderprojects/orderProjectInterfaceSettings2.json';
    let orderProjectForm2: Observable<InterfaceSettings>;

    orderProjectForm2 = this.plycaService.getInterfaceSettings(orderProjectFormURL2).pipe(
      catchError((e: any) => this.ignoreError(e, orderProjectFormURL2))
    );

    return forkJoin(
      this.plycaService.getInterfaceSettings(baseFormURL),
      orderProjectForm, // 0
      orderBreakdownForm, // 1
      orderProjectForm2
    ).pipe(
      map((result: InterfaceSettings[]) => {
        let mergedInterfacceSettings = result[0];
        let interfaceToMerge = result[1];
        if (interfaceToMerge) {
          mergedInterfacceSettings = this.formService.mergeInterfaceSettings(mergedInterfacceSettings, interfaceToMerge);
        }
        interfaceToMerge = result[2];
        if (interfaceToMerge && this.model.ui.planningBudgetData) {
          mergedInterfacceSettings = this.formService.mergeInterfaceSettings(mergedInterfacceSettings, interfaceToMerge);
        }

        interfaceToMerge = result[3];
        if (interfaceToMerge) {
          mergedInterfacceSettings = this.formService.mergeInterfaceSettings(mergedInterfacceSettings, interfaceToMerge);
        }
        let formConfig = this.newFormConfig();
        formConfig.interfaceSetting = mergedInterfacceSettings;
        formConfig.isModalWindow = false;
        formConfig.showValidations = true;
        return formConfig;
      }),
      finalize(() => { console.log('Creado') })
    );

  }
  private ignoreError(e: any, channeFormURL: string): ObservableInput<InterfaceSettings> {
    console.error('Error al obtener definicion del formulario ' + channeFormURL);
    return of(undefined);
  }


  private newFormConfig(): FormConfig {
    let formConfig: FormConfig;
    formConfig = new FormConfig('orderprojects/orderProjectInterfaceSettings.json', undefined, this.model);
    return formConfig;
  }

  close() { }

  dtoToModel(dto: OrderProjectDTO): Observable<OrderProjectModel> {
    let model = new OrderProjectModel();
    model.dto = dto;
    model.ui = {
      isContextWork: false
    }

    model.ui.includeCoordinationData = false;
    model.ui.includeIncidence = false;
    model.ui.planningBudgetData = false;
    model.ui.personaDataRequired = false;

    if (this.task !== undefined) {
      model.ui.isContextWork = true;
      if (this.task.work && this.task.work.orderProject && this.task.work.orderProject.context
        && this.task.work.orderProject.context.configurations) {
        if (this.task.work.orderProject.context.configurations.includeInternalCode) {
          model.ui.includeInternalCode = this.task.work.orderProject.context.configurations.includeInternalCode.value;
        }
        if (this.task.work.orderProject.context.configurations.includeCoordinationData) {
          model.ui.includeCoordinationData = this.task.work.orderProject.context.configurations.includeCoordinationData.value;
        }
        if (this.task.work.orderProject.context.configurations.includeIncidence) {
          model.ui.includeIncidence = this.task.work.orderProject.context.configurations.includeIncidence.value;
        }
        if (this.task.work.orderProject.context.configurations.planningBudgetData) {
          model.ui.planningBudgetData = this.task.work.orderProject.context.configurations.planningBudgetData.value;
        }
        if (this.task.work.orderProject.context.configurations.personaDataRequired) {
          model.ui.personaDataRequired = this.task.work.orderProject.context.configurations.personaDataRequired.value;
        }


      }
    }
    if (dto.phase !== undefined && (dto.phase.identifier === '0<>EXPFASE' || dto.phase.identifier === '400<>EXPFASE')) {
      model.ui.isPreviusPhase = true;
    } else {
      model.ui.isPreviusPhase = false;
    }
    this.setAnnuities(dto, model);

    this.setConceptsList(dto, model);

    if (model.dto.orderCoordination && model.dto.orderCoordination.proposalCoordinator2) {
      let proposalCoordinator2Aux = Array<Coordination2DTO>();
      model.dto.orderCoordination.proposalCoordinator2.forEach(proposal => {
        let coordinator = new Coordination2DTO();
        coordinator.coordinator = proposal;
        proposalCoordinator2Aux.push(coordinator);
      });
      model.dto.orderCoordination.proposalCoordinatorClient = proposalCoordinator2Aux;
    }

    let modelObs: Observable<OrderProjectModel>;
    modelObs = of(model);
    return modelObs;
  }

  modelToDTO(model: OrderProjectModel): OrderProjectDTO {
    if (model.dto.orderCoordination && model.dto.orderCoordination.proposalCoordinatorClient) {
      let proposalCoordinator2Aux = Array<PersonDTO>();
      model.dto.orderCoordination.proposalCoordinatorClient.forEach(proposal => {
        proposalCoordinator2Aux.push(proposal.coordinator);
      });
      model.dto.orderCoordination.proposalCoordinator2 = proposalCoordinator2Aux;
    }

    if (model.dto.budgetaryBreakDownList !== undefined) {
      model.dto.budgetaryBreakDownList.forEach(bugdetaryBreakdown => {
        if (bugdetaryBreakdown.incomeBreakdownList !== undefined) {
          bugdetaryBreakdown.incomeBreakdownList.forEach(incomeBreakdown => {
            incomeBreakdown.year = bugdetaryBreakdown.year;
          });
        }
        if (bugdetaryBreakdown.costBreakdownList !== undefined) {
          bugdetaryBreakdown.costBreakdownList.forEach(costBreakdown => {
            costBreakdown.year = bugdetaryBreakdown.year;
          });
        }
        if (bugdetaryBreakdown.totalBreakdownList !== undefined) {
          bugdetaryBreakdown.totalBreakdownList.forEach(totalBreakdown => {
            totalBreakdown.year = bugdetaryBreakdown.year;
          });
        }
        this.addGrossMargin(model);
      });
    }
    if (this.task) {
      this.task.work.orderProject = model.dto;
      this.task.work.orderProject.context = this.task.work.context;

    }
    return model.dto;
  }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'Expediente de Encargo';
    headerInfo.titleIcon = 'fas fa-envelope-open-text';
    // TODO pendiente de extraer datos para nueva comm
    // headerInfo.project = this.model.dto.project;
    return headerInfo;
  }

  getObjectIdentifier(): string {
    let identifier: string;
    if (this.task && this.task.work) {
      identifier = this.task.work.orderProject.identifier;
    } else if (this.identifier) {
      identifier = this.identifier;
    } else {
      // nuevo contrato
      identifier = 'new';
    }
    return identifier;
  }


  getServiceURL(): string {
    return this.configuration.UserApiUrl + this.configuration.ApiVersion + 'orderprojects/';
  }

  initHeaderActions() {
    this.subscribe(this.headerActionsService
      .addAction('Calculo Duracion', 'fas fa-calendar-check', 'btn-primary', !this.model.ui.isPreviusPhase)
      , (() => {
        this.getDeadlines();
      }));
    this.subscribe(this.headerActionsService
      .addAction('Expedientes presupuestarios', 'fas fa-search', 'btn-primary', this.model.ui.planningBudgetData)
      , (() => {
        this.searchBudgetaryProject(this.model);
      }));
    this.subscribe(this.headerActionsService
      .addAction('Verificar', 'fas fa-check', 'btn-primary', true)
      , (() => {
        this.validateOrderProject();
      }));
    this.subscribe(this.headerActionsService
      .addAction('Guardar', 'fas fa-save', 'btn-primary', true)
      , (
        () => {
          if (this.task !== undefined) {
            this.cleanWorkOrderProject();
            this.subscribe(this.saveIfValid());
          } else {
            this.subscribe(this.validate(false), result => {
              if (result.result === ResultTypeDTO.ERROR) {
                this.waitService.cancelWaiting();
                this.uiService.showConfirmMessage({
                  message: 'Se han detectado errores que impiden la tramitación. ¿Desea guardar el expediente?',
                  header: 'Confirmacion',
                  icon: 'pi pi-exclamation-triangle',
                  accept: () => {

                    console.log('Grabando expediente...');
                    this.subscribe(this.save(true), _model => {
                      if (_model) {
                        this.goToDossierInfo(_model);
                      } else {
                        this.goToDossierInfo(this.model.dto);
                      }
                    },
                      error => {
                        this.plycaErrorHandler.showServerError(error);
                      });

                  },
                  reject: () => {
                    this.waitService.cancelWaiting();
                    console.log('No hace nada...');
                  }

                });
              } else if (result.result === ResultTypeDTO.OK) {
                this.subscribe(this.save(), _model => {
                  this.waitService.cancelWaiting();
                  if (_model) {
                    this.showConfirmMessage(_model);
                  } else {
                    this.showConfirmMessage(this.model.dto);
                  }

                });
              } else {
                // Error de validación FATAL
                this.waitService.cancelWaiting();
              }
            }
            )

          }
        }));
    this.headerActionsService.addDivider();
    this.addBack();
  }

  showConfirmMessage(_orderProject: OrderProjectDTO) {
    this.uiService.showConfirmMessage({
      // ¿Desea iniciar la tramitación de la incidencia?
      message: this.translateService.instant('ContractModification.message_start_processing'),
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.waitService.startWaiting();
        this.subscribe(this.plycaService.startProject(_orderProject, this.getServiceURL())
          .pipe(
            finalize(() => {
              this.waitService.cancelWaiting();
            })
          ),
          () => {
            this.goToDossierInfo(_orderProject);
          },
          () => {
            console.log('Error');
          }
        );
      },
      reject: () => {
        this.goToDossierInfo(_orderProject);
        console.log('Saliendo...');
      }
    });
  }

  goToDossierInfo(_orderProject: OrderProjectDTO) {
    this.router.navigate(['dossierInfo/' + _orderProject.identifier], {
    });
  }



  validateOrderProject() {

    this.subscribe(this.validate(), (result => {
      if (result.result === ResultTypeDTO.OK) {
        this.uiService.showMessage(
          'Se ha validado correctamente.',
          'Aviso',
          'errorStyle'
        );
      }
    }))
  }

  protected addBack() {
    this.subscribe(
      this.headerActionsService
        .addAction(
          'General.back',
          'fas fa-chevron-left',
          'btn-outline-secondary',
          true
        )
      , (success => {
        if (this.task !== undefined) {
          this.cleanWorkOrderProject();
        }
        this.salir();
      }));
  }

  private cleanWorkOrderProject() {
    // this.waitService.startWaiting();

  }

  private setAnnuities(dto: OrderProjectDTO, model: OrderProjectModel): void {
    if (dto.annuities !== undefined) {
      model.ui.annuitiesList = [];
      dto.annuities.forEach(annuity => {
        model.ui.annuitiesList.push({
          'label': '' + annuity,
          'value': annuity
        });

      });
    }
  }

  // Inicializamos las listas de conceptos y meses.
  private setConceptsList(dto: OrderProjectDTO, model: OrderProjectModel): void {
    model.ui.incomeConcepts = dto.incomeConcepts;
    model.ui.costConcepts = dto.costConcepts;
    model.ui.incomeBreakdownList = dto.incomeBreakdownList;
    model.ui.costBreakdownList = dto.costBreakdownList;
    model.ui.totalBreakdownList = dto.totalBreakdownList;
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.functions.push({
      identifier: 'changeAnnuity',
      fn: this.changeAnnuity
    });
    formConfig.functions.push({
      identifier: 'valuePem',
      fn: this.valuePem
    });
    formConfig.functions.push({
      identifier: 'valueAmountTotalConcepts',
      fn: this.valueAmountTotalConcepts
    });
    formConfig.functions.push({
      identifier: 'editableAmountTotalConcepts',
      fn: this.editableAmountTotalConcepts
    });

    // Método para añadir nuevas filas en la tabla total anualidades
    formConfig.functions.push({
      identifier: 'addNewRecordAnnuity',
      fn: this.addNewRecordAnnuity
    });
    // Calcula el importe total de la anualidad: IMPORTE TOTAL EJECUCIÓN POR ANUALIDAD (CON 5,5% Y SIN IVA) + IVA POR ANUALIDAD
    formConfig.functions.push({
      identifier: 'valueAmountAnnuity',
      fn: this.valueAmountAnnuity
    });
    // Calcula el importe total de la cartera: IMPORTE TOTAL POR ANUALIDAD + PRODUCCIÓN PENDIENTE
    formConfig.functions.push({
      identifier: 'valueTotalAmountAnnuity',
      fn: this.valueTotalAmountAnnuity
    });

    // Método para calcular el total de los gastos corporativos
    formConfig.functions.push({
      identifier: 'valueCorporateExpenses',
      fn: this.valueCorporateExpenses
    });
    // Método para añadir nuevas filas en la tabla total anualidades
    formConfig.functions.push({
      identifier: 'addNewRecord',
      fn: this.addNewRecord
    });

    formConfig.functions.push({
      identifier: 'addTotalIncomeAmount',
      fn: this.addTotalIncomeAmount
    });

    formConfig.functions.push({
      identifier: 'addTotalProductionAmount',
      fn: this.addTotalProductionAmount
    });

    formConfig.functions.push({
      identifier: 'addTotalCostAmount',
      fn: this.addTotalCostAmount
    });

    formConfig.functions.push({
      identifier: 'addTotalAmount',
      fn: this.addTotalAmount
    });

    formConfig.functions.push({
      identifier: 'addIncomeAmount',
      fn: this.addIncomeAmount
    });
    formConfig.functions.push({
      identifier: 'searchBudgetaryProject',
      fn: this.searchBudgetaryProject
    });
    formConfig.functions.push({
      identifier: 'clearDeptarmentData',
      fn: this.clearDeptarmentData
    });

    formConfig.functions.push({
      identifier: 'clearAreaData',
      fn: this.clearAreaData
    });

    formConfig.functions.push({
      identifier: 'changeOrderValidityFrom',
      fn: this.changeOrderValidityFrom
    });

    formConfig.functions.push({
      identifier: 'changeOrderValidityUntil',
      fn: this.changeOrderValidityUntil
    });
    formConfig.functions.push({
      identifier: 'valueTotalPem',
      fn: this.valueTotalPem
    });

    formConfig.functions.push({
      identifier: 'valueTotalCorporateExpenses',
      fn: this.valueTotalCorporateExpenses
    });

    formConfig.functions.push({
      identifier: 'valueTotalTax',
      fn: this.valueTotalTax
    });

    formConfig.functions.push({
      identifier: 'valueTotalOrderProject',
      fn: this.valueTotalOrderProject
    });

    formConfig.functions.push({
      identifier: 'valueCategoryTotalAmount',
      fn: this.valueCategoryTotalAmount
    });

    formConfig.functions.push({
      identifier: 'valueWorkTotalAmount',
      fn: this.valueWorkTotalAmount
    });

    formConfig.functions.push({
      identifier: 'addGrossMargin',
      fn: this.addGrossMargin
    });

    formConfig.functions.push({
      identifier: 'updateModificationDate',
      fn: this.updateModificationDate
    });

    return super.configureFormConfig(formConfig);
  }

  // Al cambiar la anualidad se debe cambiar la tabla de anualidades.
  public changeAnnuity(model: any) {
    if (model.dto.selectedAnnuity) {
      model.dto.orderBudget.annuityAmount.forEach(annuityAmount => {
        annuityAmount.year = model.dto.selectedAnnuity;
      });
    }

  }

  // Al cambiar la anualidad se debe cambiar la tabla de anualidades.
  public valuePem(model: any) {
    let totalAmount = 0.0;
    if (model.concepts) {
      model.concepts.forEach(concept => {
        if (concept.conceptType && concept.conceptType.identifier === '1<>SARGA_CONCEPTO_IMPORTE') {
          if (concept.amount) {
            if (totalAmount !== 0.0) {
              totalAmount = totalAmount + concept.amount;
            } else {
              totalAmount = concept.amount;
            }
          }
        }

      });
    }
    return totalAmount;

  }


  // El dato IMPORTE TOTAL EJECUCION POR ANUALIDAD (CON 5,5% Y SIN IVA) tiene que ser dato calculado del sumatorio de:
  // IMPORTE EJECUCION POR ANUALIDAD (SIN 5,5% Y SIN IVA) + IMPORTE GASTOS CORPORATIVOS POR ANUALIDAD.
  public editableAmountTotalConcepts(model: any) {
    if (model?.conceptType?.identifier === '3<>SARGA_CONCEPTO_IMPORTE') {
      return true;
    } else return true;
  }

  public valueAmountTotalConcepts(model: any) {
    //model: concepto
    // model._parent: listado
    let amount = 0.0;
    let concepts = model?._parent?.concepts;
    if (model && concepts && model?.conceptType?.identifier === '3<>SARGA_CONCEPTO_IMPORTE') {
      let totalAmount1 = 0.0;
      let totalAmount2 = 0.0;
      concepts.forEach(concept => {
        if (concept.conceptType && concept.conceptType.identifier === '1<>SARGA_CONCEPTO_IMPORTE') {
          totalAmount1 = concept.amount;
        }
        if (concept.conceptType && concept.conceptType.identifier === '2<>SARGA_CONCEPTO_IMPORTE') {
          totalAmount2 = concept.amount;
        }
      });
      amount = ((totalAmount1 && totalAmount2) ? totalAmount1 + totalAmount2 : (totalAmount1 ? totalAmount1 : (totalAmount2 ? totalAmount2 : 0.0)));
    } else {
      amount = model.amount;
    }
    return amount;
  }

  // Al cambiar la anualidad se debe cambiar la tabla de anualidades.
  public valueCorporateExpenses(model: any) {
    let totalAmount = 0.0;
    if (model.concepts) {
      model.concepts.forEach(concept => {
        if (concept.conceptType && concept.conceptType.identifier === '2<>SARGA_CONCEPTO_IMPORTE') {
          if (concept.amount) {
            if (totalAmount !== 0.0) {
              totalAmount = totalAmount + concept.amount;
            } else {
              totalAmount = concept.amount;
            }
          }
        }

      });
    }
    return totalAmount;

  }


  private roundDecimals(value: number, decimals?: number): number {
    let digits: number = (decimals || decimals === 0) ? decimals : 2;
    let multiplier = Math.pow(10, digits);
    return Math.round((value + Number.EPSILON) * multiplier) / multiplier;
  }

  addNewRecordAnnuity() {

    let _this = this as unknown as formElementComponent;
    let annuityAmountDTO = new AnnuityAmountDTO;


    let today = new Date();

    if (!_this.model.dto.orderBudget.annuitiesAmount) {
      annuityAmountDTO.year = today.getFullYear();
    }
    annuityAmountDTO.amount = 0.0;
    let totalConcepts = lodash.cloneDeep(this.model.dto.totalConcepts);
    annuityAmountDTO.concepts = totalConcepts;

    this.model.dto.orderBudget.annuitiesAmount.push(annuityAmountDTO);

    _this.editRow(annuityAmountDTO);

  }

  addNewRecord() {

    let _this = this as unknown as formElementComponent;
    let bugdetaryBreakdownDTO = new BugdetaryBreakdownDTO;
    let today = new Date();
    bugdetaryBreakdownDTO.creationDate = today;
    if (!this.model.dto.budgetaryBreakDownList || this.model.dto.budgetaryBreakDownList.length === 0) {
      this.model.dto.budgetaryBreakDownList = [];
      bugdetaryBreakdownDTO.year = today.getFullYear();
    }
    bugdetaryBreakdownDTO.modificationDate = today;
    bugdetaryBreakdownDTO.costBreakdownList = [];
    bugdetaryBreakdownDTO.incomeBreakdownList = [];
    bugdetaryBreakdownDTO.totalBreakdownList = [];
    bugdetaryBreakdownDTO.incomeBreakdownList = this.model.dto.incomeBreakdownList;
    bugdetaryBreakdownDTO.costBreakdownList = this.model.dto.costBreakdownList;
    bugdetaryBreakdownDTO.totalBreakdownList = this.model.dto.totalBreakdownList;

    this.model.dto.budgetaryBreakDownList.push(bugdetaryBreakdownDTO);

    _this.editRow(bugdetaryBreakdownDTO);
  }

  valueAmountAnnuity(model: any) {
    let totalAmount = 0.0;
    if (model.concepts) {
      model.concepts.forEach(concept => {
        if (concept.conceptType && concept.conceptType.identifier === '3<>SARGA_CONCEPTO_IMPORTE') {
          if (concept.amount) {
            if (totalAmount !== 0.0) {
              totalAmount = totalAmount + concept.amount;
            } else {
              totalAmount = concept.amount;
            }
          }
        }
        if (concept.conceptType && concept.conceptType.identifier === '4<>SARGA_CONCEPTO_IMPORTE') {
          if (concept.amount) {
            if (totalAmount !== 0.0) {
              totalAmount = totalAmount + concept.amount;
            } else {
              totalAmount = concept.amount;
            }
          }
        }
      });
    }
    return totalAmount;
  }

  valueTotalAmountAnnuity(model: any) {
    let totalAmount = 0.0;
    if (model.concepts) {
      model.concepts.forEach(concept => {
        if (concept.conceptType && concept.conceptType.identifier === '5<>SARGA_CONCEPTO_IMPORTE') {
          if (concept.amount) {
            if (totalAmount !== 0.0) {
              totalAmount = totalAmount + concept.amount;
            } else {
              totalAmount = concept.amount;
            }
          }
        }

      });
    }
    if (model.amount) {
      totalAmount = totalAmount + model.amount;
    }
    return totalAmount;
  }

  // Calculado: Sumatorio de los datos INGRESOS SIN 5,5% Y SIN IVA+ CORPORATIVOS 5,5%
  addTotalProductionAmount(model: any) {
    let totalAmount = 0;
    if (model !== undefined && model.incomeBreakdownList !== undefined) {
      model.incomeBreakdownList.forEach(incomeBreakDown => {
        if (incomeBreakDown.incomeConcept !== undefined && incomeBreakDown.amountMonths !== undefined) {
          if (incomeBreakDown.incomeConcept.identifier === '4<>SARGA_CONCEPTO_INGRESO' || incomeBreakDown.incomeConcept.identifier === '5<>SARGA_CONCEPTO_INGRESO') {
            incomeBreakDown.amountMonths.forEach(incomeMonth => {
              if (incomeMonth.amount !== undefined) {
                totalAmount = totalAmount + incomeMonth.amount;
              }
            });
          }
        }
      });
    }
    return totalAmount;
  }

  // Calculado: Sumatorio de los datos INGRESOS SIN 5,5% Y SIN IVA+ CORPORATIVOS 5,5%
  addTotalIncomeAmount(model: any) {
    let totalAmount = 0;
    if (model !== undefined && model.incomeBreakdownList !== undefined) {
      model.incomeBreakdownList.forEach(incomeBreakDown => {
        if (incomeBreakDown.incomeConcept !== undefined
          && incomeBreakDown.amount !== undefined
          && incomeBreakDown.amountMonths !== undefined) {
          if (incomeBreakDown.incomeConcept.identifier === '1<>SARGA_CONCEPTO_INGRESO' || incomeBreakDown.incomeConcept.identifier === '2<>SARGA_CONCEPTO_INGRESO') {
            incomeBreakDown.amountMonths.forEach(incomeMonth => {
              if (incomeMonth.amount !== undefined) {
                totalAmount = totalAmount + incomeMonth.amount;
              }
            });
          }
        }
      });
    }
    return totalAmount;
  }

  // Suma todos los costes.
  addTotalCostAmount(model: any) {
    let totalAmount = 0;
    if (model !== undefined && model.costBreakdownList !== undefined) {
      model.costBreakdownList.forEach(costBreakDown => {
        if (costBreakDown.costConcept !== undefined && costBreakDown.amountMonths !== undefined) {
          costBreakDown.amountMonths.forEach(costMonth => {
            if (costMonth.amount !== undefined) {
              totalAmount = totalAmount + costMonth.amount;
            }
          });
        }
      });
    }
    return totalAmount;
  }

  addTotalAmount(model: any) {
    let totalAmount = 0;
    // Si la accion es CANCELAR (por ejemplo escape, o aspa), al cerrar el desglsoe de meses.
    if (model._parent === undefined) {
      model._parent = this.model;
    }
    // Si la accion es ACEPTAR, al cerrar el desglsoe de meses.
    if (model !== undefined && model.totalConcept !== undefined) {
      // TOTAL INGRESOS: Dato autocalculado por cada mes del año. Sumatorio de los datos INGRESOS SIN 5,5% Y SIN IVA+ CORPORATIVOS 5,5%
      if (model.totalConcept.identifier === '1<>SARGA_CONCEPTO_TOTALES') {
        // TOTAL DEL COSTE!
        totalAmount = 0;
        // Limpiamos la suma del desglose por meses de los totales.
        model._parent.totalBreakdownList.forEach(totalElement => {
          if (totalElement.totalConcept.identifier === '1<>SARGA_CONCEPTO_TOTALES') {
            totalElement.amountMonths.forEach(totalMonthElement => {
              totalMonthElement.amount = 0;
            });
          }
        });
        if (model._parent !== undefined && model._parent.incomeBreakdownList !== undefined) {
          model._parent.incomeBreakdownList.forEach(incomeBreakdown => {
            if (incomeBreakdown.incomeConcept !== undefined && incomeBreakdown.amount !== undefined) {
              if (incomeBreakdown.incomeConcept.identifier === '1<>SARGA_CONCEPTO_INGRESO' ||
                incomeBreakdown.incomeConcept.identifier === '2<>SARGA_CONCEPTO_INGRESO') {
                totalAmount = totalAmount + incomeBreakdown.amount;
                // HAY QUE DESGLOSAR EL TOTAL POR MESES
                if (incomeBreakdown.amountMonths !== undefined) {
                  // Bucle para recorrer los meses del coste
                  incomeBreakdown.amountMonths.forEach(incomeMonth => {
                    model._parent.totalBreakdownList.forEach(totalElement => {
                      if (totalElement.totalConcept.identifier === '1<>SARGA_CONCEPTO_TOTALES') {
                        totalElement.amountMonths.forEach(totalMonthElement => {
                          if (totalMonthElement.month.identifier === incomeMonth.month.identifier) {
                            totalMonthElement.amount = totalMonthElement.amount + incomeMonth.amount;
                            totalMonthElement.month = incomeMonth.month;
                          }
                        });
                      }
                    });
                  });
                }
              }
            }
          });
          // return totalAmount;
        }
        // TOTAL PRODUCCION: Dato autocalculado por cada mes del año. Sumatorio de los datos PRODUCCIÓN PREVISTA + PRODUCCIÓN PENDIENTE
      } else if (model.totalConcept.identifier === '2<>SARGA_CONCEPTO_TOTALES') {
        // TOTAL DEL COSTE!
        totalAmount = 0;
        // Limpiamos la suma del desglose por meses de los totales.
        model._parent.totalBreakdownList.forEach(totalElement => {
          if (totalElement.totalConcept.identifier === '2<>SARGA_CONCEPTO_TOTALES') {
            totalElement.amountMonths.forEach(totalMonthElement => {
              totalMonthElement.amount = 0;
            });
          }
        });
        if (model._parent !== undefined && model._parent.incomeBreakdownList !== undefined) {
          model._parent.incomeBreakdownList.forEach(incomeBreakdown => {
            if (incomeBreakdown.incomeConcept !== undefined && incomeBreakdown.amount !== undefined) {
              if (incomeBreakdown.incomeConcept.identifier === '4<>SARGA_CONCEPTO_INGRESO' ||
                incomeBreakdown.incomeConcept.identifier === '5<>SARGA_CONCEPTO_INGRESO') {
                totalAmount = totalAmount + incomeBreakdown.amount;
                // HAY QUE DESGLOSAR EL TOTAL POR MESES
                if (incomeBreakdown.amountMonths !== undefined) {
                  // Bucle para recorrer los meses del coste
                  incomeBreakdown.amountMonths.forEach(incomeMonth => {
                    model._parent.totalBreakdownList.forEach(totalElement => {
                      if (totalElement.totalConcept.identifier === '2<>SARGA_CONCEPTO_TOTALES') {
                        totalElement.amountMonths.forEach(totalMonthElement => {
                          if (totalMonthElement.month.identifier === incomeMonth.month.identifier) {
                            totalMonthElement.amount = totalMonthElement.amount + incomeMonth.amount;
                            totalMonthElement.month = incomeMonth.month;
                          }
                        });
                      }
                    });
                  });
                }
              }
            }
          });
        }
        // TOTAL COSTES PERSONAL: Sumatorio de los datos GASTOS DE PERSONAL +
        // DIETAS Y GASTOS Y ATENCIONES + FORMACIÓN Y OTROS GASTOS SOCIALES
      } else if (model.totalConcept.identifier === '3<>SARGA_CONCEPTO_TOTALES') {
        totalAmount = 0;
        // Limpiamos la suma del desglose por meses de los totales.
        model._parent.totalBreakdownList.forEach(totalElement => {
          if (totalElement.totalConcept.identifier === '3<>SARGA_CONCEPTO_TOTALES') {
            totalElement.amountMonths.forEach(totalMonthElement => {
              totalMonthElement.amount = 0;
            });
          }
        });
        if (model._parent !== undefined && model._parent.costBreakdownList !== undefined) {
          model._parent.costBreakdownList.forEach(costBreakdown => {
            if (costBreakdown.costConcept !== undefined && costBreakdown.amount !== undefined) {
              if (costBreakdown.costConcept.identifier === '16<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '17<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '18<>SARGA_CONCEPTO_COSTES') {
                totalAmount = totalAmount + costBreakdown.amount;
                // HAY QUE DESGLOSAR EL TOTAL POR MESES
                if (costBreakdown.amountMonths !== undefined) {
                  // Bucle para recorrer los meses del coste
                  costBreakdown.amountMonths.forEach(costMonth => {
                    model._parent.totalBreakdownList.forEach(totalElement => {
                      if (totalElement.totalConcept.identifier === '3<>SARGA_CONCEPTO_TOTALES') {
                        totalElement.amountMonths.forEach(totalMonthElement => {
                          if (totalMonthElement.month.identifier === costMonth.month.identifier) {
                            totalMonthElement.amount = totalMonthElement.amount + costMonth.amount;
                            totalMonthElement.month = costMonth.month;
                          }
                        });
                      }
                    });
                  });
                }
              }
            }
          });
        }
        // TOTAL COMPRAS: Sumatorio de los datos COMPRAS
      } else if (model.totalConcept.identifier === '4<>SARGA_CONCEPTO_TOTALES') {
        // devuelve el total del concepto de costes: COMPRAR
        totalAmount = 0;
        // Limpiamos la suma del desglose por meses de los totales.
        model._parent.totalBreakdownList.forEach(totalElement => {
          if (totalElement.totalConcept.identifier === '4<>SARGA_CONCEPTO_TOTALES') {
            totalElement.amountMonths.forEach(totalMonthElement => {
              totalMonthElement.amount = 0;
            });
          }
        });
        if (model._parent !== undefined && model._parent.costBreakdownList !== undefined) {
          model._parent.costBreakdownList.forEach(costBreakdown => {
            if (costBreakdown.costConcept !== undefined && costBreakdown.amount !== undefined) {
              if (costBreakdown.costConcept.identifier === '1<>SARGA_CONCEPTO_COSTES') {
                totalAmount = totalAmount + costBreakdown.amount;
                // HAY QUE DESGLOSAR EL TOTAL POR MESES
                if (costBreakdown.amountMonths !== undefined) {
                  costBreakdown.amountMonths.forEach(costMonth => {
                    model._parent.totalBreakdownList.forEach(totalElement => {
                      if (totalElement.totalConcept.identifier === '4<>SARGA_CONCEPTO_TOTALES') {
                        totalElement.amountMonths.forEach(totalMonthElement => {
                          if (totalMonthElement.month.identifier === costMonth.month.identifier) {
                            totalMonthElement.amount = totalMonthElement.amount + costMonth.amount;
                            totalMonthElement.month = costMonth.month;
                          }
                        });
                      }
                    });
                  });
                }
                // Fin desglose del total por meses
              }
            }
          });
        }
        // TOTAL TRABAJOS REALIZADOS POR OTRAS EMPRESAS: Sumatorio de los datos TRABAJOS REALIZADOS POR OTRAS EMPRESAS EXTERNAS
      } else if (model.totalConcept.identifier === '5<>SARGA_CONCEPTO_TOTALES') {
        // devuelve el total del concepto de costes: TRABAJOS REALIZADOS POR OTRAS EMPRESAS EXTERNAS (B)
        totalAmount = 0;
        model._parent.totalBreakdownList.forEach(totalElement => {
          if (totalElement.totalConcept.identifier === '5<>SARGA_CONCEPTO_TOTALES') {
            totalElement.amountMonths.forEach(totalMonthElement => {
              totalMonthElement.amount = 0;
            });
          }
        });
        if (model._parent !== undefined && model._parent.costBreakdownList !== undefined) {
          model._parent.costBreakdownList.forEach(costBreakdown => {
            if (costBreakdown.costConcept !== undefined && costBreakdown.amount !== undefined) {
              if (costBreakdown.costConcept.identifier === '2<>SARGA_CONCEPTO_COSTES') {
                totalAmount = totalAmount + costBreakdown.amount;
                // HAY QUE DESGLOSAR EL TOTAL POR MESES
                if (costBreakdown.amountMonths !== undefined) {
                  costBreakdown.amountMonths.forEach(costMonth => {
                    model._parent.totalBreakdownList.forEach(totalElement => {
                      if (totalElement.totalConcept.identifier === '5<>SARGA_CONCEPTO_TOTALES') {
                        totalElement.amountMonths.forEach(totalMonthElement => {
                          if (totalMonthElement.month.identifier === costMonth.month.identifier) {
                            totalMonthElement.amount = totalMonthElement.amount + costMonth.amount;
                            totalMonthElement.month = costMonth.month;
                          }
                        });
                      }
                    });
                  });
                }
                // Fin desglose del total por meses
              }
            }
          });
          // return totalAmount;
        }
        // TRABAJOS REALIZADOS POR PERSONAL EMPRESA EXTERNO AL DTO: Sumatorio de los datos
        // TRABAJOS REALIZADOS POR OTRAS DEPARTAMENTOS FRAS INTERNAS
      } else if (model.totalConcept.identifier === '6<>SARGA_CONCEPTO_TOTALES') {
        totalAmount = 0;
        model._parent.totalBreakdownList.forEach(totalElement => {
          if (totalElement.totalConcept.identifier === '6<>SARGA_CONCEPTO_TOTALES') {
            totalElement.amountMonths.forEach(totalMonthElement => {
              totalMonthElement.amount = 0;
            });
          }
        });
        if (model._parent !== undefined && model._parent.costBreakdownList !== undefined) {
          model._parent.costBreakdownList.forEach(costBreakdown => {
            if (costBreakdown.costConcept !== undefined && costBreakdown.amount !== undefined) {
              if (costBreakdown.costConcept.identifier === '3<>SARGA_CONCEPTO_COSTES') {
                totalAmount = totalAmount + costBreakdown.amount;
                // HAY QUE DESGLOSAR EL TOTAL POR MESES
                if (costBreakdown.amountMonths !== undefined) {
                  costBreakdown.amountMonths.forEach(costMonth => {
                    model._parent.totalBreakdownList.forEach(totalElement => {
                      if (totalElement.totalConcept.identifier === '6<>SARGA_CONCEPTO_TOTALES') {
                        totalElement.amountMonths.forEach(totalMonthElement => {
                          if (totalMonthElement.month.identifier === costMonth.month.identifier) {
                            totalMonthElement.amount = totalMonthElement.amount + costMonth.amount;
                            totalMonthElement.month = costMonth.month;
                          }
                        });
                      }
                    });
                  });
                }
                // Fin desglose del total por meses
              }
            }
          });
          // return totalAmount;
        }
        // TOTAL OTROS COSTES: Sumatorio de los datos ALQUILERES I/G (suministros, oficinas, ...)
        // ALQUILERES SOPORTADOS (suministros, oficinas, ...),
        // VEHÍCULOS SOPORTADOS (gasolina, alquiler, parking, ...), REPARACIONES Y CONSERVACIÓN,
        // SERVICIOS PROFESIONALES, PRIMAS DE SEGUROS,GASTOS FINANCIEROS
        // PUBLICIDAD, SUMINISTROS I/G (teléfono, luz, agua, ...), SUMINISTROS SOPORTADOS (teléfono, luz, agua, ...),
        // OTROS SERVICIOS, TRIBUTOS ,DOTACIÓN A LA AMORTIZACIÓN
      } else if (model.totalConcept.identifier === '7<>SARGA_CONCEPTO_TOTALES') {
        totalAmount = 0;
        model._parent.totalBreakdownList.forEach(totalElement => {
          if (totalElement.totalConcept.identifier === '7<>SARGA_CONCEPTO_TOTALES') {
            totalElement.amountMonths.forEach(totalMonthElement => {
              totalMonthElement.amount = 0;
            });
          }
        });
        if (model._parent !== undefined && model._parent.costBreakdownList !== undefined) {
          model._parent.costBreakdownList.forEach(costBreakdown => {
            if (costBreakdown.costConcept !== undefined && costBreakdown.amount !== undefined) {
              if (costBreakdown.costConcept.identifier === '4<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '5<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '6<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '7<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '8<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '9<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '10<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '11<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '12<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '13<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '14<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '15<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '19<>SARGA_CONCEPTO_COSTES') {
                totalAmount = totalAmount + costBreakdown.amount;
                // HAY QUE DESGLOSAR EL TOTAL POR MESES
                if (costBreakdown.amountMonths !== undefined) {
                  costBreakdown.amountMonths.forEach(costMonth => {
                    model._parent.totalBreakdownList.forEach(totalElement => {
                      if (totalElement.totalConcept.identifier === '7<>SARGA_CONCEPTO_TOTALES') {
                        totalElement.amountMonths.forEach(totalMonthElement => {
                          if (totalMonthElement.month.identifier === costMonth.month.identifier) {
                            totalMonthElement.amount = totalMonthElement.amount + costMonth.amount;
                            totalMonthElement.month = costMonth.month;
                          }
                        });
                      }
                    });
                  });
                }
                // Fin desglose del total por meses
              }
            }
          });
          // return totalAmount;
        }
        // TOTAL COSTES: SUMATORIO DE TODOS LOS ANTERIORES, (SIN LOS INGRESOS)
      } else if (model.totalConcept.identifier === '8<>SARGA_CONCEPTO_TOTALES') {
        totalAmount = 0;
        model._parent.totalBreakdownList.forEach(totalElement => {
          if (totalElement.totalConcept.identifier === '8<>SARGA_CONCEPTO_TOTALES') {
            totalElement.amountMonths.forEach(totalMonthElement => {
              totalMonthElement.amount = 0;
            });
          }
        });
        if (model._parent !== undefined && model._parent.costBreakdownList !== undefined) {
          model._parent.costBreakdownList.forEach(costBreakdown => {
            if (costBreakdown.costConcept !== undefined && costBreakdown.amount !== undefined) {
              if (costBreakdown.costConcept.identifier === '1<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '2<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '3<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '4<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '5<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '6<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '7<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '8<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '9<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '10<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '11<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '12<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '13<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '14<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '15<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '16<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '17<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '18<>SARGA_CONCEPTO_COSTES' ||
                costBreakdown.costConcept.identifier === '19<>SARGA_CONCEPTO_COSTES') {
                totalAmount = totalAmount + costBreakdown.amount;
                // HAY QUE DESGLOSAR EL TOTAL POR MESES
                if (costBreakdown.amountMonths !== undefined) {
                  costBreakdown.amountMonths.forEach(costMonth => {
                    model._parent.totalBreakdownList.forEach(totalElement => {
                      if (totalElement.totalConcept.identifier === '8<>SARGA_CONCEPTO_TOTALES') {
                        totalElement.amountMonths.forEach(totalMonthElement => {
                          if (totalMonthElement.month.identifier === costMonth.month.identifier) {
                            totalMonthElement.amount = totalMonthElement.amount + costMonth.amount;
                            totalMonthElement.month = costMonth.month;
                          }
                        });
                      }
                    });
                  });
                }
                // Fin desglose del total por meses
              }
            }
          });

        }
        // MARGEN PRESUPUESTADO BRUTO (INCLUIDO 5,5%): (TOTAL INGRESOS + TOTAL COSTES) / (TOTAL INGRESOS * 100)
      } else if (model.totalConcept.identifier === '9<>SARGA_CONCEPTO_TOTALES') {
        totalAmount = 0;
        model._parent.totalBreakdownList.forEach(totalElement => {
          if (totalElement.totalConcept.identifier === '9<>SARGA_CONCEPTO_TOTALES') {
            totalElement.amountMonths.forEach(totalMonthElement => {
              totalMonthElement.amount = 0;
            });
          }
        });
        let totalIncome = 0;
        let totalIncomePerMont = [];
        let totalCost = 0;
        let totalCostPerMont = [];
        if (model._parent !== undefined && model._parent.totalBreakdownList !== undefined) {
          model._parent.totalBreakdownList.forEach(totalBreakdown => {
            if (totalBreakdown.totalConcept !== undefined &&
              totalBreakdown.totalConcept.identifier === '1<>SARGA_CONCEPTO_TOTALES' && totalBreakdown.amount !== undefined) {
              totalIncome = totalBreakdown.amount;
              if (totalBreakdown.amountMonths !== undefined) {
                totalIncomePerMont = totalBreakdown.amountMonths;
              }
            }
          });
        }
        if (model._parent !== undefined && model._parent.totalBreakdownList !== undefined) {
          model._parent.totalBreakdownList.forEach(totalBreakdown => {
            if (totalBreakdown.totalConcept !== undefined &&
              totalBreakdown.totalConcept.identifier === '8<>SARGA_CONCEPTO_TOTALES' && totalBreakdown.amount !== undefined) {
              totalCost = totalBreakdown.amount;
              if (totalBreakdown.amountMonths !== undefined) {
                totalCostPerMont = totalBreakdown.amountMonths;
              }
            }
          });
        }
        // CAMPO TOTAL MOSTRADO EN LA TABLA. Hay que desglosarlo. return (TOTAL INGRESOS+TOTAL COSTES)/(TOTAL INGRESOS)*100 (%)
        if (totalIncomePerMont !== undefined && totalCostPerMont !== undefined) {
          totalIncomePerMont.forEach(elementIncome => {
            totalCostPerMont.forEach(elementCost => {

              if (elementIncome.month.identifier === elementCost.month.identifier) {
                let incomeCost = elementIncome.amount;
                let costCost = elementCost.amount;
                let month = elementIncome.month;
                model.amountMonths.forEach(element => {
                  if (element.month.identifier === month.identifier) {
                    element.month = month;
                    if (incomeCost !== 0) {
                      element.amount = ((incomeCost - costCost) / costCost) * 100;
                    } else {
                      element.amount = 0.0;
                    }
                  }
                });
              }
            });
          });
        };

        if (totalIncome !== 0.0) {
          totalAmount = ((totalIncome - totalCost) / totalCost) * 100;
        } else {
          totalAmount = 0.0;
        }

      } else if (model.totalConcept.identifier === '10<>SARGA_CONCEPTO_TOTALES') {
        // MARGEN PRESUPUESTADO NETO SIN 5%: (TOTAL INGRESOS SIN 5% + TOTAL COSTES) / (TOTAL INGRESOS * 100)
        totalAmount = 0;
        model._parent.totalBreakdownList.forEach(totalElement => {
          if (totalElement.totalConcept.identifier === '10<>SARGA_CONCEPTO_TOTALES') {
            totalElement.amountMonths.forEach(totalMonthElement => {
              totalMonthElement.amount = 0;
            });
          }
        });
        let totalIncomeWithoutPercent = 0;
        let totalIncomePerMontWithoutPercent = [];
        let totalCost = 0;
        let totalCostPerMont = [];
        let totalIncome = 0;
        let totalIncomePerMont = [];

        // TOTAL INGRESOS (del listado de totales)
        if (model._parent !== undefined && model._parent.totalBreakdownList !== undefined) {
          model._parent.totalBreakdownList.forEach(totalBreakdown => {
            if (totalBreakdown.totalConcept !== undefined &&
              totalBreakdown.totalConcept.identifier === '1<>SARGA_CONCEPTO_TOTALES' && totalBreakdown.amount !== undefined) {
              totalIncome = totalBreakdown.amount;
              if (totalBreakdown.amountMonths !== undefined) {
                totalIncomePerMont = totalBreakdown.amountMonths;
              }
            }
          });
        }

        // TOTAL INGRESOS SIN 5% (del listado de ingresos)
        if (model._parent !== undefined && model._parent.incomeBreakdownList !== undefined) {
          model._parent.incomeBreakdownList.forEach(incomeBreakdown => {
            if (incomeBreakdown.incomeConcept !== undefined &&
              incomeBreakdown.incomeConcept.identifier === '1<>SARGA_CONCEPTO_INGRESO' && incomeBreakdown.amount !== undefined) {
              totalIncomeWithoutPercent = incomeBreakdown.amount;
              if (incomeBreakdown.amountMonths !== undefined) {
                totalIncomePerMontWithoutPercent = incomeBreakdown.amountMonths;
              }
            }
          });
        }

        // TOTAL COSTES
        if (model._parent !== undefined && model._parent.totalBreakdownList !== undefined) {
          model._parent.totalBreakdownList.forEach(totalBreakdown => {
            if (totalBreakdown.totalConcept !== undefined &&
              totalBreakdown.totalConcept.identifier === '8<>SARGA_CONCEPTO_TOTALES' && totalBreakdown.amount !== undefined) {
              totalCost = totalBreakdown.amount;
              if (totalBreakdown.amountMonths !== undefined) {
                totalCostPerMont = totalBreakdown.amountMonths;
              }
            }
          });
        }
        // CAMPO TOTAL MOSTRADO EN LA TABLA. Hay que desglosarlo. return (TOTAL INGRESOS+TOTAL COSTES)/(TOTAL INGRESOS)*100 (%)
        if (totalIncomePerMontWithoutPercent !== undefined && totalCostPerMont !== undefined) {
          totalIncomePerMontWithoutPercent.forEach(elementIncomeWithoutPercent => {
            totalCostPerMont.forEach(elementCost => {
              if (elementIncomeWithoutPercent.month.identifier === elementCost.month.identifier) {
                totalIncomePerMont.forEach(elementIncome => {
                  if (elementIncome.month.identifier === elementCost.month.identifier) {
                    let incomeCostWithoutPercent = elementIncomeWithoutPercent.amount;
                    let incomeCost = elementIncome.amount;
                    let costCost = elementCost.amount;
                    let month = elementIncomeWithoutPercent.month;
                    model.amountMonths.forEach(element => {
                      if (element.month.identifier === month.identifier) {
                        element.month = month;
                        if (incomeCost !== 0.0) {
                          element.amount = ((incomeCostWithoutPercent - costCost) / costCost) * 100;
                        } else {
                          element.amount = 0.0;
                        }
                      }
                    });
                  }
                });
              }
            });
          });
        };

        if (totalIncome !== 0) {
          totalAmount = ((totalIncomeWithoutPercent - totalCost) / totalCost) * 100;
        } else {
          totalAmount = 0.0;
        }

      }
    }

    return totalAmount;
  }

  addIncomeAmount(model: any) {
    let totalAmount = 0;
    if (model !== undefined && model.amountMonths !== undefined) {
      model.amountMonths.forEach(element => {
        if (element.amount !== undefined) {
          if (totalAmount !== 0) {
            totalAmount = totalAmount + element.amount;
          } else {
            totalAmount = element.amount;
          }
        }
      });
    }
    return totalAmount;
  }

  searchBudgetaryProject(model: any) {
    let config: DynamicDialogConfig = {
      header: 'Criterios de adjudicación',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' },
      styleClass: 'searchStyle'
    };
    config['context'] = new SearchSettingDTOModal('SEARCH.BUDGETARY_PROJECT');
    const ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(ref.onClose, (budgetaryProject: BudgetaryProjectDTO) => {
      if (budgetaryProject) {
        model.dto.budgetaryProjectRelated = budgetaryProject;
        // obtener referencia al formelement que invoca para poder utilizar el metodo _addRow
        // let _this = this as unknown as formElementComponent;
        let newRow = new BugdetaryBreakdownDTO();
        let today = new Date();


        if (!model.dto.budgetaryBreakDownList || model.dto.budgetaryBreakDownList.length === 0) {
          model.dto.budgetaryBreakDownList = [];
        }
        if (budgetaryProject.budgetaryBreakDownList) {
          budgetaryProject.budgetaryBreakDownList.forEach(element => {
            if (element.year === today.getFullYear()) {
              newRow = element;
              newRow.modificationDate = today;

              model.dto.budgetaryBreakDownList.push(newRow);

            }
          });
        }


        // _this.editRow(newRow);
      }
    });
  }

  clearDeptarmentData(model: any) {
    if (model.dto.organizationalUnit === undefined) {
      model.dto.organizationalInfo.area = undefined;
      model.dto.organizationalInfo.activity = undefined;
    } else if (model.dto.organizationalInfo.area !== undefined) {
      if (model.dto.organizationalInfo.area.unitParent.identifier !== model.dto.organizationalUnit.identifier) {
        model.dto.organizationalInfo.area = undefined;
        model.dto.organizationalInfo.activity = undefined;
      }
    }
  }

  clearAreaData(model: any) {
    if (model.dto.organizationalInfo.area === undefined) {
      model.dto.organizationalInfo.activity = undefined;
    } else {
      if (model.dto.organizationalInfo.area.identifier !== undefined && model.dto.organizationalInfo.activity !== undefined
        && model.dto.organizationalInfo.activity.properties !== undefined
        && model.dto.organizationalInfo.activity.properties.ORGANISMOHEX !== undefined) {
        if (model.dto.organizationalInfo.activity.properties.ORGANISMOHEX !== model.dto.organizationalInfo.area.identifier) {
          model.dto.organizationalInfo.activity = undefined;
        }
      }
    }
  }

  changeOrderValidityFrom(model: any) {
    if (model.dto.plannedPeriod) {
      if (model.dto.plannedPeriod.orderValidityFrom && model.dto.plannedPeriod.orderValidityUntil) {

      }
    }

  }

  changeOrderValidityUntil(model: any) {

  }

  // Total de los importe ejecutado para todas las anualidades del encargo
  public valueTotalPem(model: any) {
    let totalAmount = 0.0;
    if (model.dto.orderBudget.annuitiesAmount) {
      model.dto.orderBudget.annuitiesAmount.forEach(annuityAmount => {
        if (annuityAmount.concepts) {
          annuityAmount.concepts.forEach(concept => {
            if (concept.conceptType && concept.conceptType.identifier === '1<>SARGA_CONCEPTO_IMPORTE') {
              if (concept.amount) {
                if (totalAmount !== 0.0) {
                  totalAmount = totalAmount + concept.amount;
                } else {
                  totalAmount = concept.amount;
                }
              }
            }
          });
        }
      });
    }
    return totalAmount;

  }

  // Total de los gastos corporativos para todas las anualidades del encargo
  public valueTotalCorporateExpenses(model: any) {
    let totalAmount = 0.0;
    if (model.dto.orderBudget.annuitiesAmount) {
      model.dto.orderBudget.annuitiesAmount.forEach(annuityAmount => {
        if (annuityAmount.concepts) {
          annuityAmount.concepts.forEach(concept => {
            if (concept.conceptType && concept.conceptType.identifier === '2<>SARGA_CONCEPTO_IMPORTE') {
              if (concept.amount) {
                if (totalAmount !== 0.0) {
                  totalAmount = totalAmount + concept.amount;
                } else {
                  totalAmount = concept.amount;
                }
              }
            }

          });
        }
      });
    }
    return totalAmount;

  }

  // Total iva para todas las anualidades del encargo
  public valueTotalTax(model: any) {
    let totalAmount = 0.0;
    if (model.dto.orderBudget.annuitiesAmount) {
      model.dto.orderBudget.annuitiesAmount.forEach(annuityAmount => {
        if (annuityAmount.concepts) {
          annuityAmount.concepts.forEach(concept => {
            if (concept.conceptType && concept.conceptType.identifier === '4<>SARGA_CONCEPTO_IMPORTE') {
              if (concept.amount) {
                if (totalAmount !== 0.0) {
                  totalAmount = totalAmount + concept.amount;
                } else {
                  totalAmount = concept.amount;
                }
              }
            }

          });
        }
      });
    }
    return totalAmount;

  }

  // Total del encargo
  public valueTotalOrderProject(model: any) {
    let totalAmount = 0.0;
    if (model.dto.orderBudget.executionAmount) {
      totalAmount = totalAmount + model.dto.orderBudget.executionAmount
    }
    if (model.dto.orderBudget.corporateExensesAmount) {
      totalAmount = totalAmount + model.dto.orderBudget.corporateExensesAmount
    }
    if (model.dto.orderBudget.budget.totalTaxes) {
      totalAmount = totalAmount + model.dto.orderBudget.budget.totalTaxes
    }
    return totalAmount;

  }


  public valueCategoryTotalAmount(model: any) {
    // Coste total: (Coste actualizado* % asignación)*nº personas
    let total = 0.0;
    if (model.category) {

      // Coste salarial: Cálculo salario anual * % Contratación
      let wageCost = 0.0;
      // Coste seguridad social: coste salarial * %SS
      let socialSecurityCost = 0.0;
      // Coste total: Coste salarial + Coste seguridad social
      let totalcost = 0.0;
      // Coste actualizado: Coste Total + (Coste Total* % de actualización salarial)
      let updatedCost = 0.0;
      if (model.procurementPercentage !== undefined) {
        wageCost = model.category.anualSalaryByCategory * (model.procurementPercentage / 100);
        if (model.boxSS !== undefined) {
          socialSecurityCost = wageCost * (model.boxSS / 100);

          totalcost = wageCost + socialSecurityCost;

          if (model.salaryUpdatePercentage !== undefined) {
            updatedCost = totalcost + (totalcost * (model.salaryUpdatePercentage / 100));
            if (model.assignmentOrderPercentage !== undefined && model.numbersPerson !== undefined) {
              total = (updatedCost * (model.assignmentOrderPercentage / 100)) * model.numbersPerson;
            }
          }
        }
      }

    }
    model.totalAmount = total;

  }

  public valueWorkTotalAmount(model: any) {
    // Coste total: Coste actualizado * % asignación
    let total = 0.0;
    if (model.person) {

      // Coste salarial: Cálculo salario anual * % Contratación
      let wageCost = 0.0;
      // Coste seguridad social: coste salarial * %SS
      let socialSecurityCost = 0.0;
      // Coste total: Coste salarial + Coste seguridad social
      let totalcost = 0.0;
      // Coste actualizado: Coste Total + (Coste Total* % de actualización salarial)
      let updatedCost = 0.0;

      if (model.person.workingDay !== undefined) {
        wageCost = model.person.anualSalaryByWorker * (model.person.workingDay / 100);

        if (model.person.cost !== undefined) {
          socialSecurityCost = wageCost * (model.person.cost / 100);

          totalcost = wageCost + socialSecurityCost;

          if (model.salaryUpdatePercentage !== undefined) {
            updatedCost = totalcost + (totalcost * (model.salaryUpdatePercentage / 100));
            if (model.assignmentOrderPercentage !== undefined) {
              total = updatedCost * (model.assignmentOrderPercentage / 100)
            }
          }
        }
      }

    }
    model.totalAmount = total;

  }

  addGrossMargin(model: any) {
    let totalAmount = 0;
    let totalIncome = 0;
    let totalCost = 0;
    if (model.dto.budgetaryBreakDownList !== undefined) {
      model.dto.budgetaryBreakDownList.forEach(bugdetaryBreakdown => {
        if (bugdetaryBreakdown !== undefined) {
          if (bugdetaryBreakdown.totalIncome !== undefined) {
            totalIncome = bugdetaryBreakdown.totalIncome;
          }
          if (bugdetaryBreakdown.totalCost !== undefined) {
            totalCost = bugdetaryBreakdown.totalCost;
          }
          if (totalIncome !== undefined && totalCost !== undefined && totalIncome > 0) {
            totalAmount = ((totalIncome + totalCost) / totalIncome) * 100;
            bugdetaryBreakdown.grossMargin = totalAmount;
          }
        }
      });
    }
  }

  updateModificationDate(model: any) {
    let today = new Date();
    if (model !== undefined && model.modificationDate !== undefined) {
      model.modificationDate = today;
    }
    return true;
  }


  getDeadlines() {
    if (this.model.dto.plannedPeriod === undefined
      || this.model.dto.plannedPeriod.orderValidityFrom === undefined
      || this.model.dto.plannedPeriod.orderValidityUntil === undefined) {
      this.uiService.showMessage(
        'Deben informarse las fechas de vigencia del encargo para poder calcular la duración.',
        'Aviso',
        'errorStyle'
      );
    } else {
      let cliente = this.appConfig.getValue('cliente');
      if (this.model.dto.plannedPeriod.orderValidityUntil !== undefined &&
        this.model.dto.plannedPeriod.orderValidityFrom.getTime() > this.model.dto.plannedPeriod.orderValidityUntil.getTime()) {
        this.uiService.showMessage(
          'La fecha de vigencia Desde indicada no puede ser superior a la fecha de vigencia Hasta.',
          'Aviso',
          'errorStyle'
        );
      } else {
        this.subscribe(this.plycaService.getDeadLinesGen(this.model.dto.plannedPeriod, this.getServiceURL()
        ), ((result2: OrderPlannedPeriodDTO) => {
          this.model.dto.plannedPeriod.extension = result2.extension;

        }));
      }
    }

  }


}
